import visit from '@/api/customer/visitation'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  salers: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SALE(state, data){
    state.salers = data
  },
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  CLEAR_SETUP(state){
    state.salers = []
    state.customers = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return visit.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return visit.store(data)
  },
  update(context, { id, data }) {
    return visit.update(id, data)
  },
  destroy(context, id){
    return visit.destroy(id)
  },
  async fetchResources(context){
    let sale = await visit.user()
      context.commit('SET_SALE', sale.data)
  },
  getCustomer(context, arrtributes = {}){
    return visit.customer({ params: arrtributes })
  }
}
